import React from 'react';
import HoverPanel from '../utils/HoverPanel';
import SlotTooltip from '../build/SlotTooltip';
import SetTooltip from '../build/SetTooltip';

/**
 * Renders the item/set tooltips fixed-positioned at the Generator page
 * level. Pure presentational wrapper around the state from
 * `useSlotTooltips` — see docs/generator-slicing.md cluster G.
 *
 * HoverPanel owns the placement for both, including the correction that keeps a
 * tall one (a weapon with damages, meta and a legendary line) inside the
 * viewport, and the hit-strip an interactive one spans the gap with.
 */
const GeneratorTooltips = ({
    tooltip,
    tooltipPos,
    tooltipElRef,
    onTooltipLeave,
    onTooltipDismiss,
    build,
    lang,
    weaponMaging,
    setTooltipData,
    setTooltipPosition,
}) => (
    <>
        {tooltip.item && (
            <HoverPanel
                ref={tooltipElRef}
                pos={tooltipPos}
                interactive={tooltip.interactive}
                stacked={tooltip.stacked}
                onMouseLeave={onTooltipLeave}
            >
                <SlotTooltip
                    item={tooltip.item}
                    build={build}
                    lang={lang}
                    interactive={tooltip.interactive}
                    onOpenItem={tooltip.onOpenItem}
                    onDismiss={onTooltipDismiss}
                    weaponMaging={weaponMaging}
                    itemMaging={tooltip.slot != null ? (build?.getItemMaging?.(tooltip.slot) ?? null) : null}
                />
            </HoverPanel>
        )}

        {setTooltipData.set && (
            <HoverPanel pos={setTooltipPosition}>
                <SetTooltip set={setTooltipData.set} lang={lang} />
            </HoverPanel>
        )}
    </>
);

export default GeneratorTooltips;
